interface AlertProps {
  variant: 'error' | 'success';
  message: string;
  onDismiss?: () => void;
}

export function Alert({ variant, message, onDismiss }: AlertProps) {
  const styles =
    variant === 'error'
      ? 'bg-red-500/10 border-ll-error text-ll-error'
      : 'bg-green-500/10 border-ll-success text-ll-success';

  return (
    <div
      className={`border-l-4 rounded-r-lg p-4 mb-4 text-sm flex items-start justify-between ${styles}`}
      role="alert"
    >
      <span>{message}</span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="ml-4 shrink-0 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Dismiss"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <line x1="4" y1="4" x2="12" y2="12" />
            <line x1="12" y1="4" x2="4" y2="12" />
          </svg>
        </button>
      )}
    </div>
  );
}
